import api from '../../api';
import models from '../../../models';
import output from '../../../utils/output-writer';
import { WrappedRegisterToolFuncType } from '../tool-definition';
import { createCallToolResult, createTextContent } from '../output-parser';

const getFiredAlertsInputSchema = models.tool.getFiredAlertsInput;

export function setup(register: WrappedRegisterToolFuncType) {
  register(
    'get-fired-alerts-for-monitors',
    {
      title: 'Get Fired Alerts',
      description: `List alert incidents in the specified channel for the given monitors. Each incident in the response includes a link to the related message in the channel. Always include and display these message links in the tool output.
      
      CRITICAL REQUIREMENTS:
      - Channel Identifier: You must provide a channel identifier (either channelName or channelId) that you receive explicitly from the user. If you do not receive it, do not create a call until you ask the user for this input.
      - Monitor Name Conversion: You MUST review each monitor name in the monitors array. Refer to the input schema description for the detailed conversion rules, and apply those rules to each monitorName. 
      
      Before providing 'from' and 'to' datetime run the "date +"%Z %z"" command to determine the user's current time and **timezone**.

      When reporting the results, convert all times from UTC to the user's local timezone. Report the links as hyperlinks.`,
      inputSchema: getFiredAlertsInputSchema,
    },
    async (input) => {
      output.info('Running get fired alerts for monitors');

      const result = await api.getFiredAlerts(input);

      return createCallToolResult({
        contentBlocks: [createTextContent(JSON.stringify(result, null, 2))],
      });
    }
  );
}

export default { setup };
